import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

// style rules
import { Colors, Sizes, Animation, Typography } from "../../styles";

const Filters = ({ languages, setSelectedLanguage, selectedLanguage }) => {
	const renderedLanguages = languages.map((filter) => {
		return (
			<Filter
				variants={Animation.cards.opacityVariants}
				initial={"initial"}
				animate={"animate"}
				key={filter.slug}
				active={selectedLanguage && selectedLanguage === filter.slug ? 1 : 0}
				onClick={() => setSelectedLanguage(filter.slug)}
				onKeyPress={() => setSelectedLanguage(filter.slug)}
			>
				{filter.title}
			</Filter>
		);
	});

	return (
		<FiltersContainer>
			<Title>Choose Your Language</Title>
			<FiltersWrapper>
				<Row>{renderedLanguages}</Row>
			</FiltersWrapper>
		</FiltersContainer>
	);
};

export default Filters;

Filters.propTypes = {
	languages: PropTypes.array,
	setSelectedLanguage: PropTypes.func,
	selectedLanguage: PropTypes.string,
};

const FiltersContainer = styled.div``;

const Title = styled.p`
	color: ${Colors.base.black};
	font-weight: ${Typography.fontWeight.black};
	margin-bottom: 1.5rem !important;
	letter-spacing: -0.0015em;
	color: ${Colors.base.black};
`;

const FiltersWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		flex-direction: row;
	}
`;

const Row = styled.div`
	display: flex;
	gap: 1.7rem;
	flex-wrap: wrap;
	flex: 1;
	align-items: center;
`;

const Filter = styled(motion.button)`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1.3rem;
	background: ${(props) =>
		props.active ? Colors.cneAreas.limeGreen : "transparent"};
	background-size: 0% 100%;
	border: 1px solid
		${(props) =>
		props.active
			? Colors.cneAreas.limeGreen
			: props.isRides
				? Colors.base.white
				: Colors.base.black};
	color: ${(props) =>
		props.active
			? Colors.base.black
			: props.isRides
				? Colors.base.white
				: Colors.base.black};
	padding: 0.7rem 2.2rem;
	transition: all 0.7s;

	${(props) =>
		!props.active &&
		`&:hover,
		 &:focus {
			border: 1px solid ${Colors.cneAreas.limeGreen} ;
			color: black;
			background: transparent;
			background-image: ${Colors.gradients.green};
			background-repeat: no-repeat;
			background-size: 200% 100%;
			transition: all .7s;
		}`}
`;
